const BE_ENDPOINT =  "/api"; //  "http://127.0.0.1:8383"; //     via proxy server for prod //     "http://192.168.50.124:8383"; // for testing

export class UserService {

    loginUser(data) {
        let loginData = 'grant_type=password&username='+data.username+'&password='+data.password;

        return fetch(BE_ENDPOINT + '/token', {
            method: 'POST',
                body: loginData,
                headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json'
            })
        }).then(res =>  res);
    }

    createUser(data) {
        return fetch(BE_ENDPOINT + '/users/register', {method: 'POST',
            body: JSON.stringify(data),
            headers: new Headers({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        }).then(res =>  res);
    }

    resetPassword(data) {
        return fetch(BE_ENDPOINT + '/users/resetpassword', {method: 'POST',
            body: JSON.stringify(data),
            headers: new Headers({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        }).then(res =>  res);
    }

    getTokenFromRefreshToken(refreshToken) {
        return fetch(BE_ENDPOINT + '/refresh_token', {method: 'POST',
            body: JSON.stringify({refresh_token: refreshToken}),
            headers: new Headers({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        }).then(res =>  res);
    }

    getCurrentUser(accessToken) {
        return this.fetchAuthorized('/users/me', 'GET', accessToken);
    }

    getGeneratedPlaylists(accessToken) {
        return this.fetchAuthorized('/users/generatedplaylists', 'get', accessToken)
    }

    removeGeneratedPlaylist(accessToken, playlistId) {
        return this.fetchAuthorized('/users/generatedplaylists/remove/'+playlistId, 'delete', accessToken);
    }

    updateGeneratedPlaylist(data, accessToken) {
        return this.updateAuthorized('/users/generatedplaylists/'+data.id, data, accessToken);
    }

    getSpotifyData(accessToken) {
        return  this.fetchAuthorized('/users/spotifydata', 'get', accessToken);
    }

    createSpotifyApp(data, accessToken) {
        return fetch(BE_ENDPOINT+'/users/spotifyapp/new',{
            method: 'POST',
            body: JSON.stringify(data),
            headers: new Headers({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            })
        })
    }

    updateSpotifyApp(data, accessToken) {
        return fetch(BE_ENDPOINT+'/users/spotifyapp/'+data.id,{
            method: 'PATCH',
            body: JSON.stringify(data),
            headers: new Headers({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            })
        })
    }

    giveAccessToSpotifyApp(spotifyapp_id, sharewith_username, accessToken) {
        const data={spotifyapp_id: spotifyapp_id, username: sharewith_username, slots: 1}
        return this.createAuthorized('/users/spotifyappid_username', data, accessToken);
    }

    createSpotifyUser(data, accessToken) {
        return this.createAuthorized('/users/spotifyuser/new', data, accessToken);
    }

    updateSpotifyUser(data, accessToken) {
        return this.updateAuthorized('/users/spotifyuser/'+data.id, data, accessToken);
    }

    connectSpotifyUser(spotifyuser_id, accessToken) {
        return this.fetchAuthorized('/users/spotifyuser/connect/'+spotifyuser_id, 'get', accessToken)
    }

    connectSpotifyUserCode(code, spotifyuser_id, accessToken) {
        return this.fetchAuthorized('/users/spotifyuser/connect/' + spotifyuser_id +'/' + code, 'get', accessToken)
    }

    updateAuthorized(path, data, accessToken) {
        return fetch(BE_ENDPOINT+path,{
            method: 'PATCH',
            body: JSON.stringify(data),
            headers: new Headers({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            })
        })
    }

    createAuthorized(path, data, accessToken) {
        return fetch(BE_ENDPOINT+path,{
            method: 'POST',
            body: JSON.stringify(data),
            headers: new Headers({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            })
        })
    }

    fetchAuthorized(path, method, accessToken) {
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${accessToken}`
        })

        return fetch(BE_ENDPOINT+ path , {
            method: method,
            headers: headers
        }).then(res => res);
    }

}